// (Routes that do NOT require a token or authentication)
import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../shared/components/Login";
import Callback from "../shared/components/Callback";

export function PublicRoutes() {
    return (
        <Routes>
            {/* LOGIN is public */}
            <Route path="/login" element={<Login />} />

            {/* REDIRECTING (callback) is public */}
            <Route path="/redirecting" element={<Callback />} />

            {/* Add any other public routes you need here */}
        </Routes>
    );
}
